// A retired version of a public ConfirmPH policy, exactly as it was
// published. The archive module is loaded only when someone asks for it, so
// it never adds to what an ordinary visitor downloads.
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { ARCHIVES, POLICY_BY_SLUG } from "@/content/policyVersions";
import LegalPage from "./LegalPage";
import NoIndex from "@/components/NoIndex";

export default function ArchivedPolicy() {
  const { slug, version } = useParams();
  const policy = POLICY_BY_SLUG[slug];
  const entry = policy?.versions.find((v) => v.archive === version);
  const loader = entry ? ARCHIVES[entry.archive] : null;
  const [content, setContent] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setContent(null);
    setFailed(false);
    if (!loader) return;
    let alive = true;
    loader()
      .then((mod) => { if (alive) setContent(mod[policy.exportName] || null); })
      .catch(() => { if (alive) setFailed(true); });
    return () => { alive = false; };
  }, [loader, policy]);

  if (!policy || !entry || failed) {
    return (
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14"
           data-testid="archived-policy-missing">
        <NoIndex />
        <h1 className="font-display text-3xl font-bold">Version not available</h1>
        <p className="mt-4 text-slate-700">
          There is no retired version of this policy with that date.
        </p>
        <Link to="/legal" className="underline mt-6 inline-block">← All policies</Link>
      </div>
    );
  }
  if (!content) {
    return (
      <p className="max-w-3xl mx-auto px-4 py-10 flex items-center gap-2 text-sm text-slate-500"
         role="status">
        <Loader2 className="w-4 h-4 animate-spin" /> Loading…
      </p>
    );
  }
  return (
    <>
      <NoIndex />
      <LegalPage content={content} slug={slug} archivedVersion={entry} />
    </>
  );
}
